<template>
  <!-- 预览的表单项
        @author liuguisheng
        @date 2019-9-14
  -->
  <div class="form-preview"
       :class="[`id-${formNode.id}`,pickFromItemStyle]">
    <!-- 勾选按钮 -->
    <el-checkbox v-if="itemPickControl && hasPickFun"
                 v-model="itemPickModel"></el-checkbox>
    <!-- 勾选时展示自定义名称 -->
    <div class="pick-custom-name" v-if="itemPickControl && hasPickFun && itemPickModel">{{customName}}</div>
    <!-- 组件内容 -->
    <component :formNode="formNode"
               :parent="parent"
               :is="formType && 'preview-item-'+formType">
    </component>
    <!-- 复制事件删除按钮 -->
    <div v-if="isCopied" 
         class="delete-button">
         <span class="el-icon-error"
               @click="onDelete"></span>
    </div>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplate 表单预览子级混入
 */
import { mixPreviewItemTemplate } from '@/mixins/preview_item/mix_preview_item_template.js';
// 导入勾选配置文件
import { isHasPickDic } from '@/assets/js/form_dictionary.js';

export default {
  mixins: [ mixPreviewItemTemplate ],
  props: {
    // 预览表单中的每一项
    formNode: {
      type: Object,
      default: () => ({})
    },
    // 表单项父级列表
    parent: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    /**
     * @name 勾选时样式计算
     * @returns { string } 样式的class名称
     * @author liuguisheng
     * @version 2019-12-12
    */
    pickFromItemStyle () {
      // 如果开启勾选功能，表单项样式计算
      return this.itemPickControl ? 'form-preview_pick' : ''
    },
    /**
     * @name 检测当前是否提供勾选功能
     * @returns { boolean } 是否勾选
     * @author liuguisheng
     * @version 2019-12-12
    */
    hasPickFun () {
      return isHasPickDic[this.formType]
    }
  },
  methods: {
    onDelete() {
      this.nodeActionManager(this.formNode).deleteFrom(this.parent);
    } 
  }
}
</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemTemplate.vue